export const PAYMENT_BOOST_LANG_CODES = [
  'en-US',
  'es-US',
  'be-BY',
  'ru-BY',
  'uk-UA',
  'ru-UA',
  'en-CA',
  'fr-CA',
  'de-CH',
  'fr-CH',
  'it-CH',
  'rm-CH',
  'en-IE',
  'ga-IE',
  'en-GB',
  'cy-GB',
  'gd-GB',
  'sco-GB',
  'nl-NL',
  'de-DE',
  'dsb-DE',
  'hsb-DE',
  'frr-DE',
  'nb-NO',
  'nn-NO',
]

export const PAYMENT_BOOST_SID_CONFIG = [
  { serviceId: 102837, transaction: { amount: 100 } }, // test
  { serviceId: 904933, transaction: { amount: 100 } },
  { serviceId: 904934, transaction: { amount: 100 } },
  { serviceId: 904859, transaction: { amount: 100 } },
  { serviceId: 103452, transaction: { amount: 100 } },
  { serviceId: 103453, transaction: { amount: 100 } },
  { serviceId: 101191, transaction: { amount: 0 } },
  { serviceId: 101196, transaction: { amount: 0 } },
  { serviceId: 101233, transaction: { amount: 0 } },
  { serviceId: 101234, transaction: { amount: 0 } },
  { serviceId: 103463, transaction: { amount: 100 } },
  { serviceId: 104577, transaction: { amount: 100 } },
  { serviceId: 104578, transaction: { amount: 100 } },
  { serviceId: 104342, transaction: { amount: 100 } },
  { serviceId: 101349, transaction: { amount: 0 } },
  { serviceId: 101350, transaction: { amount: 0 } },
  { serviceId: 102977, transaction: { amount: 0 } },
  { serviceId: 101277, transaction: { amount: 0 } },
]

/**
 * Przerwy w działaniu mechanizmu payment boost — okna czasowe, w których boost jest wyłączony
 * dla **wszystkich** SIDów z `PAYMENT_BOOST_SID_CONFIG` (kartowe metody płatności nie są ani
 * chowane pod „pokaż więcej”, ani degradowane na koniec listy).
 *
 * Tablica, bo zakresów może być wiele — mechanizm jest wyłączony, gdy „teraz” mieści się
 * w którymkolwiek z nich. Granice są **domknięte** (`start` i `end` włącznie).
 *
 * ⚠️ Daty zapisuj z **jawnym offsetem strefy** — bez niego `Date.parse` użyje strefy przeglądarki
 * użytkownika i przerwa zacznie/skończy się o innej godzinie dla każdego. Polska to `+02:00` w czasie
 * letnim (CEST) i `+01:00` w zimowym (CET, od ostatniej niedzieli października).
 *
 * Wpis bez żadnej granicy (`{}`) jest **ignorowany** — inaczej po cichu wyłączałby mechanizm na zawsze.
 * Wpis z samym `start` = przerwa bezterminowa od tej daty; z samym `end` = przerwa do tej daty.
 */
export const PAYMENT_BOOST_PAUSE_PERIODS = [
  // PEP-1264 — promocja kart Mastercard: nie chowamy metod kartowych
  // { start: '2026-09-01T00:00:00+02:00', end: '2026-11-30T23:59:59+01:00' },
]
